module.exports = __webpack_public_path__ + "img/bjlttop.dd92abea.png";